/* eslint-disable react/jsx-no-literals */
import React from 'react'
import { css } from 'styled-components'

const InfinitySymbol: React.FC = () => {
  return (
    <span
      css={css`
        font-family: 'icon-font';
        font-size: 28px;
        content: '\e900';
        color: #fff;
      `}
    >
      
    </span>
  )
}

export default InfinitySymbol
